var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurbujaPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 741,
    viewBox: "0 0 682 741",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m659.99 461.79c14.224-37.545 22.01-78.257 22.01-120.79 0-188.33-152.67-341-341-341s-341 152.67-341 341 152.67 341 341 341c23.107 0 45.676-2.298 67.493-6.679-0.29 17.611-9.734 44.02-14.493 55.179-4.4 12 7.833 10.333 14.5 8 171.6-68.4 240.17-215.17 253-280-0.502 1.102-1.006 2.198-1.51 3.287zm-113.8 151.6c-3.181 2.399-6.405 4.745-9.671 7.035 3.203-2.224 6.428-4.566 9.671-7.035z",
    clipRule: "evenodd",
    fill: "#7DB8F2",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200.99,
    cy: 348.56,
    r: 0.64041,
    fill: "#5df99c",
    stroke: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurbujaPending);
export default __webpack_public_path__ + "static/media/burbuja-pending.c48bd88ec35c401d7acb808ed6cb983f.svg";
export { ForwardRef as ReactComponent };